export const uniqueByKeepLast = (data, key) => {
  return [...new Map(data.map(x => [key(x), x])).values()];
};

export const removeByKey = (data, key, removingKey) => {
  return data.filter(element => key(element) !== removingKey);
};
